<template>
  <v-app>
    <v-container fluid class="article-actions">
      <v-row>
        <v-col md="2" cols="12">
          <v-subheader>عنوان</v-subheader>
        </v-col>
        <v-col md="8" cols="12">
          <v-text-field placeholder="عنوان" v-model="title"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="2" cols="12">
          <v-subheader>نوع تخفیف</v-subheader>
        </v-col>
        <v-col md="8" cols="12">
          <v-select
            v-model="discountType"
            :items="discountTypes"
            reverse
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="2" cols="12">
          <v-subheader>دسته ها</v-subheader>
        </v-col>
        <v-col md="8" cols="12">
          <v-select
            v-model="category"
            :items="categories"
            reverse
            multiple
            chips
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="2" cols="12">
          <v-subheader>برند ها</v-subheader>
        </v-col>
        <v-col md="8" cols="12">
          <v-select
            v-model="brand"
            :items="brands"
            reverse
            multiple
            chips
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="2" cols="12">
          <v-subheader>محصولات</v-subheader>
        </v-col>
        <v-col md="8" cols="12">
          <v-select
            v-model="product"
            :items="products"
            reverse
            multiple
            chips
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="2" cols="12">
          <v-subheader>تخفیف پیشنهاد</v-subheader>
        </v-col>
        <v-col md="8" cols="12">
          <!-- <v-select v-model="product" :items="products" reverse multiple chips></v-select> -->
          <v-switch v-model="isOffer"></v-switch>
        </v-col>
      </v-row>
      <v-row v-if="isOffer">
        <v-col md="2" cols="12">
          <v-subheader>پیشنهاد ها</v-subheader>
        </v-col>
        <v-col md="8" cols="12">
          <v-select
            v-model="offer"
            :items="offers"
            reverse
            chips
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="2" cols="12">
          <v-subheader>مقدار تخفیف</v-subheader>
        </v-col>
        <v-col md="8" cols="12">
          <v-text-field
            placeholder="مقدار تخفیف"
            v-model="amount"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-btn
          class="ml-4 white--text font-weight-bold indigo darken-4 white--text"
          @click="editHandler"
        >
          ثبت کردن
        </v-btn>
        <router-link to="/offer-off/discount">
          <v-btn class="white--text font-weight-bold indigo lighten-2">
            انصراف
          </v-btn>
        </router-link>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import baseURL from "@/axios";
export default {
  created() {
    // product

    axios.get(`${baseURL}Product/GetAll`).then((res) => {
      res.data.data.map((item) => {
        this.products.push({
          text: item.title,
          value: item.id,
        });
      });
    });

    //brands

    axios.get(`${baseURL}Brand/GetAll`).then((res) => {
      res.data.data.map((item) => {
        this.brands.push({
          text: item.name,
          value: item.id,
        });
      });
    });

    //categories

    axios.get(`${baseURL}ProductGroup/GetAll`).then((res) => {
      res.data.data.map((item) => {
        this.categories.push({
          text: item.name,
          value: item.id,
        });
      });
    });

    //offers

    axios.get(`${baseURL}Offer/GetAll`).then((res) => {
      res.data.data.map((item) => {
        this.offers.push({
          text: item.title,
          value: item.id,
        });
      });
    });

    // get by id

    axios.get(`${baseURL}Discount/GetById?id=${this.$route.params.id}`)
      .then((res)=>{
        this.title=res.data.data.title
        this.amount=res.data.data.amount
        this.discountType=res.data.data.id
        // title
        res.data.data.offers.map((item)=>{
          this.offer.push({
            text:item.title,
            value:item.id
          })
        })
        // offer 
        res.data.data.products.map((item)=>{
          this.product.push({
            text:item.title,
            value:item.id
          })
        })
        // product 
        res.data.data.productGroups.map((item)=>{
          this.categories.push({
            text:item.title,
            value:item.id
          })
        })
        res.data.data.brands.map((item)=>{
          this.brand.push({
            text:item.title,
            value:item.id
          })
        })

      })
  },
  data() {
    return {
      title: "",
      discountType: {
        text: null,
        value: null,
      },
      category: [],
      brand: [],
      product: [],
      offer: [],
      amount: null,
      isOffer: false,
      discountTypes: [
        {
          text: "درصد",
          value: 1,
        },
        {
          text: "مقدار",
          value: 2,
        },
      ],
      brands: [],
      categories: [],
      offers: [],
      products: [],
    };
  },
  computed: {
    ...mapGetters(["tokenValue"]),
  },
  methods: {
    async editHandler() {
      await axios
        .put(
          `${baseURL}Discount/Edit`,
          {
            id:this.$route.params.id,
            title: this.title,
            discountType: this.discountType,
            productGroupIds: this.category,
            brandIds: this.brand,
            productIds: this.product,
            isOffer: this.isOffer,
            offerId: this.offer.length>0 ?this.offer[0] :0,
            amount: this.amount,
            groupIdentifier: null,
          },
          {
            headers: {
              Authorization: `Bearer ${this.tokenValue}`,
            },
          }
        )
        .then(() => {
          this.$router.push("/offer-off/discount");
        });
    },
  },
};
</script>

<style>
.article-actions {
  background: #ffffff;
  height: auto;
}
.v-input__control {
  direction: ltr;
}
.v-input__slot {
  flex-direction: row-reverse;
}
.v-application--wrap {
  min-height: auto !important;
}
.theme--light.v-input input {
  text-align: right;
}
</style>